import { defineNuxtPlugin } from 'nuxt/app';
import { skeletonDirective } from '@app/directives/skeleton';

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.directive('skeleton', skeletonDirective);
});
